<template>
  <div class="goodsClassification">
    <div class="goodsClassification_box">
      <a-button
        type="primary"
        :style="{ margin: '0 0 24px 0' }"
        @click="showModal"
      >
        新增
      </a-button>
      <a-table
        :columns="columns"
        :row-key="(record) => record.objId"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="imgUrl1" slot-scope="imgUrl1">
<!--          {{imgUrl1}}-->
          <img class="tabel_a" :src="imgUrl1" alt="">
<!--          <img :src="imgUrl" alt="">-->
<!--          {{ categoryName}}-->
        </template>
        <template slot="operate" slot-scope="text, operate">
          <a href="javascript:;" @click="edit(operate)">编辑</a>
          <a href="javascript:;" @click="del(operate)">删除</a>
        </template>
      </a-table>
      <a-modal
        :width="820"
        centered
        v-model="visible"
        :title="title"
        @ok="handleAdd"
        :maskStyle="{ opacity: 0.1 }"
        cancelText="取消"
        okText="确定"
      >
        <a-form-item
          label=" 商品名称"
          labelAlign="left"
        >
          <a-input style="width: 300px" placeholder="请输入商品名称" v-model="categoryName" />
        </a-form-item>
        <a-form-item
          label="上传封面图片"
          labelAlign="left"
        >
          <a-upload
            :fileList="defaultFileList"
            :customRequest="upload"
            :remove="handleFileRemove"
          >
            <a-button> <a-icon type="upload" /> Upload </a-button>
          </a-upload>
        </a-form-item>
      </a-modal>
    </div>

  </div>
</template>

<script>
  import {message} from "ant-design-vue";
  import {
    categoryList,
    picUpload,
    categoryAddL,
    categoryDel,
    categoryEdit
  } from "@/api/storeApi.js";
  let columns= [
    {
      title: "编号",
      dataIndex: "objId",
      sorter: true,
      scopedSlots: { customRender: "objId" },
    },
    {
      title: "分类名称",
      align: "center",
      dataIndex: "categoryName",
    },
    {
      title: "分类图片",
      dataIndex: "imgUrl",
      align: "center",
      scopedSlots: { customRender: "imgUrl1" },
    },
    {
      title: "操作",
      dataIndex: "operate",
      sorter: true,
      scopedSlots: { customRender: "operate" },
    },
  ]
  export default {
    name: "goodsClassification",
    data(){
      return {
        fileList:[],
        defaultFileList:[],
        objId:"",
        categoryName:"",
        imageUrl:"",
        addGoods:{},
        visible:false,
        columns,
        data: [],
        title:'',
        loading: false,
        pagination: {
          current: 1,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "40", "80", "100"],
          showTotal: (total) => `共 ${total} 条`,
          pageSize: 10,
        },
      }
    },
    mounted() {
      this.loadCatList()
    },
    methods:{
      handleTableChange(pagination, filters, sorter) {
        console.log(pagination);
        this.loading = true;
        this.pagination.current = pagination.current; //重置当前页
        categoryList({ limit: 10, page: this.pagination.current }).then((res) => {
          this.data = res.data;
          console.log(res);
          this.loading = false;
        });
      },
      loadCatList(){
        categoryList({ limit: 10, page: 1 }).then(res=>{
          this.pagination.total = res.count;
          this.data = res.data;
        })
      },
      showModal() {
        this.defaultFileList = []
        this.title ='新增商品'
        this.visible = true;
      },
      upload(file) {
        const file_size = file.file.size;
        if (file_size > this.$file_max_size) {
          message.error("请确保图片大小在2M以内");
          return false;
        }
        // file是上传的文件
        const form = new FormData();
        form.append("file", file.file);
        form.append("contractName", file.file.name);
        form.append("description", file.file.name);
        picUpload(form)
          .then((res) => {
            if(res.code == '0000') {
              this.imageUrl= res.data;
              file.onSuccess(res, file);
              message.success("上传成功");
              this.defaultFileList.push({
                uid: file.file.uid,
                name: file.file.name,
                status: "done",
                url: res.data,
              });
            }else {
              file.onError(res, file);
              message.error(res.info);
            }
          })
          .catch((err) => {
            message.error("请确保图片大小在2M以内");
          });
      },
      handleFileRemove (file) {
        const name = file.name
        this.defaultFileList = this.defaultFileList.filter(item => {
          if (name !== item.name) return item
        })
        console.log(this.defaultFileList)
      },
      handleAdd(){
        if(!this.categoryName){
          message.warning("分类名称不可为空");
          return
        }
        if(!this.imageUrl || !this.defaultFileList.length){
          message.warning("分类图片不可为空");
          return
        }
        if(this.objId){
          categoryEdit({
            id:this.objId,
            imgUrl:this.defaultFileList[0].url,
            categoryName:this.categoryName
          }).then(res=>{
            message.success('添加成功');
            this.visible = false
            this.objId= ''
            this.categoryName = ''
            this.imageUrl = ''
            this.handleTableChange(this.pagination)
            this.defaultFileList = []
          })
        }else {
          categoryAddL({
            categoryName:this.categoryName,
            imgUrl:this.imageUrl
          }).then(res=>{
            message.success('添加成功');
            this.visible = false
            this.categoryName = ''
            this.imageUrl = ''
            this.handleTableChange(this.pagination)
          }).catch(e=>{
            message.warning("添加水平");
            this.visible = false
          })
        }

      },
      //删除
      del(data){
        let that = this
        this.$confirm({
          title: '提示',
          content: '是否删除分类',
          onOk() {
            return new Promise((resolve, reject) => {
              categoryDel(data.objId).then(res=>{
                message.success('删除成功')
                that.handleTableChange(that.pagination)
                setTimeout(resolve , 1000);
              })
            }).catch(() => console.log('Oops errors!'));
          },
          onCancel() {},
        });
        // categoryDel(data.objId)
      },
      //编辑
      edit(data){
        this.title = '编辑商品'
        this.categoryName = data.categoryName
        this.imageUrl = data.imgUrl
        this.objId = data.objId
        this.defaultFileList= [{
          uid: '1',
          name: data.imgUrl,
          status: 'done',
          response: 'Server Error 500', // custom error message to show
          url: data.imgUrl,
        },]
        console.log('this.defaultFileList',this.defaultFileList)
        this.$forceUpdate()
        this.visible  = true
      }

    }
  }
</script>

<style scoped lang="scss">
  .goodsClassification{
    box-sizing: border-box;
    width: 100%;
    padding:  15px;
    background-color: #ffffff;
    .goodsClassification_box{
      width: 100%;
      box-sizing: border-box;
      padding: 15px;
      background-color: #ffffff;
    }
  }
.tabel_a{
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/exchangeManagement/goodsCategory.vue